module.exports = __webpack_public_path__ + "img/8-music.ca2c9875.svg";